import { get, post, patch } from "./base";
import store from "../store";
import * as actions from "../store/actions/userProfile";
import url from "./url";
import queries from "./queries";

const { dispatch } = store;

async function getPlans({ headers = {} } = {}) {
  try {
    const query = url(queries.subscriptionList);
    dispatch(actions.getPlans());
    const response = await get(query, headers);
    dispatch(actions.getPlansSuccess(response));
    return response;
  } catch (error) {
    const errorData = error.response && error.response.data;
    return dispatch(actions.getPlansFailed(errorData || error));
  }
}

async function getSubscription({ id = "", headers = {} } = {}) {
  try {
    const query = url(queries.subscription, id);
    dispatch(actions.getCompanyPlan());
    const response = await get(query, headers);
    dispatch(actions.getCompanyPlanSuccess(response));
    return response;
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.getCompanyPlanFailed(err));
  }
}

async function selectSubscription({ data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.subscriptionSelect);
    // dispatch(actions.searchClientRequest(params.search));
    const response = await post(query, data, headers);
    // dispatch(actions.searchClientRequestSuccess(response));
    return response;
  } catch (error) {
    return error;
    // const err = (error.response && error.response.data) || error;
    // return dispatch(actions.searchClientRequestFailed(err));
  }
}

async function changeSubscription({ id = "", data = {}, headers = {} } = {}) {
  try {
    const query = url(queries.subscription, id);
    dispatch(actions.updateSubscription());
    const response = await patch(query, data, headers);
    return dispatch(actions.updateSubscriptionSuccess(response));
  } catch (error) {
    const err = (error.response && error.response.data) || error;
    return dispatch(actions.updateSubscriptionFailed(err));
  }
}

export default class subscriptionAPI {
  static plans = getPlans;

  static get = getSubscription;

  static post = selectSubscription;

  static edit = changeSubscription;
}
